function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}

function insertAfter(newNode, existingNode) {
  existingNode?.parentNode.insertBefore(newNode, existingNode?.nextSibling);
}

window.smoothScroll = function (target) {
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

const wait = (func, delay) => {
  let timeout;

  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  }
};

const setActive = (el) => {
  [...el.parentElement.children].forEach((sib) =>
    sib.classList.remove("active")
  );
  el.classList.add("active");
};

let previousSiblings = (elem) => {
  let siblings = [];
  while (elem = elem.previousElementSibling) {
    siblings.push(elem);
  }
  return siblings;
};

let nextSiblings = (elem) => {
  let siblings = [];
  while (elem = elem.nextElementSibling) {
    siblings.push(elem);
  }
  return siblings;
};

const faqBLocks = document.querySelectorAll(".faq-block");
const faqBanner = document.querySelector('.faq-banner-section');

var getInView = wait(function () {
  faqBLocks.forEach(block => {
    const _isInViewport = isInViewport(block);
    if (_isInViewport) {

      const block_id = block.getAttribute('id');
      const rel_menu = document.querySelector(`[data-toggle="${block_id}"]`);
      setActive(rel_menu.closest('li'));
    }

  });
}, 100);

document.addEventListener('scroll', getInView);
document.addEventListener("DOMContentLoaded", getInView);

const driveMenuItems = document.querySelectorAll(".drive-menu .list-item a");
driveMenuItems.forEach(listItem => {
  listItem.addEventListener("click", function (event) {
    event.preventDefault();
    smoothScroll(document.getElementById(listItem.dataset.toggle));
    setActive(listItem.closest('li'));
  })
});

const swiper_el = document.querySelector('.swiper');

const autoplayEnabled = swiper_el?.dataset?.autoplay === 'true';
const autoplaySpeedValue = swiper_el?.dataset?.autoplaySpeed?swiper_el.dataset.autoplaySpeed:5500;
const autoplaySpeed = parseInt(autoplaySpeedValue);

var swiper = swiper_el
  ? new Swiper(swiper_el, {
  loop: false,
  centeredSlides: false,
  preventClicks: true,
  preventClicksPropagation: true,
  speed: 1500,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  autoplay: autoplayEnabled ? {
    delay: autoplaySpeed,
    disableOnInteraction: false
  } : false
})
  : null;

const PRODUCTS_SLIDER_MOBILE_MQ = '(max-width: 1279px)';

function shouldProductsSliderAutoplay(sliderEl, viewport) {
  const isMobile = window.matchMedia(PRODUCTS_SLIDER_MOBILE_MQ).matches;
  const mobileEnabled = sliderEl.dataset.autoRotateMobile === 'true';
  const desktopEnabled = sliderEl.dataset.autoRotateDesktop === 'true';

  if (viewport === 'mobile') {
    return isMobile && mobileEnabled;
  }

  return !isMobile && desktopEnabled;
}

function updateProductsSliderAutoplay(swiper, sliderEl, viewport) {
  if (!swiper.autoplay) return;

  if (shouldProductsSliderAutoplay(sliderEl, viewport)) {
    swiper.autoplay.start();
  } else {
    swiper.autoplay.stop();
  }
}

function bindProductsSliderAutoplayBreakpoint(swiper, sliderEl, viewport) {
  const mobileMediaQuery = window.matchMedia(PRODUCTS_SLIDER_MOBILE_MQ);
  const handleAutoplayBreakpoint = () => updateProductsSliderAutoplay(swiper, sliderEl, viewport);

  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', handleAutoplayBreakpoint);
  } else {
    mobileMediaQuery.addListener(handleAutoplayBreakpoint);
  }
}

function getProductsSliderAutoplayConfig(sliderEl) {
  const autoRotateMobile = sliderEl.dataset.autoRotateMobile === 'true';
  const autoRotateDesktop = sliderEl.dataset.autoRotateDesktop === 'true';
  const autoRotateInterval = parseInt(sliderEl.dataset.autoRotateInterval || '3000', 10);

  if (!(autoRotateMobile || autoRotateDesktop)) return false;

  return {
    delay: autoRotateInterval,
    disableOnInteraction: false,
  };
}

const productsSwiperEl = document.querySelector('.products-swiper');
var productsSwiper = productsSwiperEl
  ? new Swiper(productsSwiperEl, {
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  preventClicks: false,
  preventClicksPropagation: false,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  },
  navigation: {
    nextEl: '.featured-products-section .swiper-button-next',
    prevEl: '.featured-products-section .swiper-button-prev',
  },
  autoplay: getProductsSliderAutoplayConfig(productsSwiperEl),
  on: {
    init(instance) {
      updateProductsSliderAutoplay(instance, productsSwiperEl, 'desktop');
    },
  },
})
  : null;

if (productsSwiper && productsSwiperEl) {
  bindProductsSliderAutoplayBreakpoint(productsSwiper, productsSwiperEl, 'desktop');
}

var productsContentSwiper = document.querySelector('.products-swiper-mobile-content')
  ? new Swiper('.products-swiper-mobile-content', {
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  effect: 'fade',
  allowTouchMove: false,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  }
})
  : null;

const productsImageSwiperEl = document.querySelector('.products-swiper-mobile-image');
var productsImageSwiper = productsImageSwiperEl
  ? new Swiper(productsImageSwiperEl, {
  loop: false,
  spaceBetween: 20,
  speed: 1000,
  breakpoints: {
    640: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 1.415,
      spaceBetween: 25,
    },
    slidesPerView: 1.415,
    spaceBetween: 25,
  },
  autoplay: getProductsSliderAutoplayConfig(productsImageSwiperEl),
  on: {
    init(instance) {
      updateProductsSliderAutoplay(instance, productsImageSwiperEl, 'mobile');
    },
  },
})
  : null;

if (productsImageSwiper && productsImageSwiperEl) {
  bindProductsSliderAutoplayBreakpoint(productsImageSwiper, productsImageSwiperEl, 'mobile');
}

if (productsContentSwiper && productsImageSwiper) {
  if (productsContentSwiper.length > 0 || productsImageSwiper.length > 0) {
    productsContentSwiper.forEach((element, index) => {
      element.controller.control = productsImageSwiper[index];
      productsImageSwiper[index].controller.control = element;
    });
  } else {
    productsContentSwiper.controller.control = productsImageSwiper;
    productsImageSwiper.controller.control = productsContentSwiper;
  }
}


function shouldCategorySliderAutoplay(sliderEl) {
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const mobileEnabled = sliderEl.dataset.autoRotateMobile === 'true';
  const desktopEnabled = sliderEl.dataset.autoRotateDesktop === 'true';
  return isMobile ? mobileEnabled : desktopEnabled;
}

function updateCategorySliderAutoplay(swiper, sliderEl) {
  if (!swiper.autoplay) return;

  if (shouldCategorySliderAutoplay(sliderEl)) {
    swiper.autoplay.start();
  } else {
    swiper.autoplay.stop();
  }
}

function initCategorySlider() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.category-slider').forEach((sliderEl) => {
    if (sliderEl.swiper) return;

    const wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = [...wrapper.querySelectorAll('.swiper-slide')];
    if (!slides.length) return;

    const duplicateMarkup = slides.map((slide) => slide.outerHTML).join('');
    wrapper.insertAdjacentHTML('beforeend', duplicateMarkup);

    const totalSlides = wrapper.querySelectorAll('.swiper-slide').length;
    const autoRotateMobile = sliderEl.dataset.autoRotateMobile === 'true';
    const autoRotateDesktop = sliderEl.dataset.autoRotateDesktop === 'true';
    const autoRotateInterval = parseInt(sliderEl.dataset.autoRotateInterval || '3000', 10);

    const swiper = new Swiper(sliderEl, {
      enabled: true,
      loop: totalSlides > 1,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      loopedSlides: slides.length,
      navigation: {
        prevEl: sliderEl.querySelector('.swiper-button-prev'),
        nextEl: sliderEl.querySelector('.swiper-button-next'),
      },
      autoplay: autoRotateMobile || autoRotateDesktop ? {
        delay: autoRotateInterval,
        disableOnInteraction: false,
      } : false,
      breakpoints: {
        375: {
          slidesPerView: 2.25,
          spaceBetween: 16,
        },
        420: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
      },
      on: {
        init(instance) {
          updateCategorySliderAutoplay(instance, sliderEl);
        },
      },
    });

    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
    const handleAutoplayBreakpoint = () => updateCategorySliderAutoplay(swiper, sliderEl);

    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleAutoplayBreakpoint);
    } else {
      mobileMediaQuery.addListener(handleAutoplayBreakpoint);
    }
  });
}

initCategorySlider();

function isUsableSwiper(instance) {
  return Boolean(
    instance &&
      !instance.destroyed &&
      instance.el &&
      typeof instance.el.querySelectorAll === 'function'
  )
}

function setBeforePrevAfterNext($swiper) {
  if (!isUsableSwiper($swiper)) return

  $swiper.el.querySelectorAll('.swiper-slide-before-prev').forEach(function (element) {
    element.classList.remove('swiper-slide-before-prev')
  })

  $swiper.el.querySelectorAll('.swiper-slide-after-next').forEach(function (element) {
    element.classList.remove('swiper-slide-after-next')
  })

  var prev = $swiper.el.querySelector('.swiper-slide-prev')
  var next = $swiper.el.querySelector('.swiper-slide-next')
  if (!prev || !next) return

  var before_prev = prev.previousElementSibling
  var after_next = next.nextElementSibling
  if (!before_prev || !after_next) return

  before_prev.classList.add('swiper-slide-before-prev')
  after_next.classList.add('swiper-slide-after-next')
}

var slider
var aboutSliderEl = document.querySelector('.about-slider')

if (aboutSliderEl) {
  var aboutslides = aboutSliderEl.querySelectorAll('.swiper-slide')
  var virtualAboutSlides = []
  var aboutslider_wrapper = aboutSliderEl.querySelector('.swiper-wrapper')

  aboutslides.forEach(function (element) {
    virtualAboutSlides.push(element.outerHTML)
  })

  if (aboutslider_wrapper) {
    virtualAboutSlides.forEach(function (element) {
      aboutslider_wrapper.innerHTML = aboutslider_wrapper.innerHTML + element
    })
  }

  slider = new Swiper(aboutSliderEl, {
    loop: true,
    speed: 1100,
    observer: true,
    observeParents: true,
    centeredSlides: true,
    loopedSlides: 3,
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 1.8,
        spaceBetween: 30,
      },
    },

    preventClicks: true,
    preventClicksPropagation: true,
    navigation: {
      prevEl: '.about-slider-wrapper .swiper-button-prev',
      nextEl: '.about-slider-wrapper .swiper-button-next',
    },
    on: {
      init: function () {
        setBeforePrevAfterNext(this)
      },
      resize: function () {
        var self = this
        requestAnimationFrame(function () {
          if (!isUsableSwiper(self)) return
          self.update()
          setBeforePrevAfterNext(self)
        })
      },
      breakpoint: function () {
        var self = this
        requestAnimationFrame(function () {
          if (!isUsableSwiper(self)) return
          self.update()
          setBeforePrevAfterNext(self)
        })
      },
      slideChangeTransitionStart: function () {
        setBeforePrevAfterNext(this)
        var sliderNavs = document.querySelector('.about-slider-wrapper .slider-navs')
        var activeSlide = aboutSliderEl.querySelector('.swiper-slide-active')
        if (!sliderNavs || !activeSlide) return
        var activeIndex = activeSlide.getAttribute('data-swiper-slide-index')
        if (activeIndex != null) sliderNavs.setAttribute('data-index', activeIndex)
      },
      slideChangeTransitionEnd: function () {
        setBeforePrevAfterNext(this)
      },
    },
  })

  var aboutSliderResizeTimer
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(aboutSliderResizeTimer)
      aboutSliderResizeTimer = setTimeout(function () {
        if (!isUsableSwiper(slider)) return
        slider.update()
        setBeforePrevAfterNext(slider)
      }, 150)
    },
    { passive: true }
  )
}

const quiz_section = document.querySelectorAll('.quiz-section');
const window_width = window.innerWidth;
quiz_section.forEach(section => {
  const blocks = section.querySelectorAll('.block');

  blocks.forEach(block => {
    const title_wrapper = block.querySelector(".title-nav-wrapper");
    const title = block.querySelector(".title-nav-wrapper .title");
    const cards_wrapper = block.querySelector(".cards-wrapper");

    const card_wrapper = block.querySelectorAll(".card-wrapper");

    const radios = block.querySelectorAll('input[type="radio"]');
    const next_button = block.querySelector('.block-check');
    const prev_button = block.querySelector('.prev-button');
    prev_button?.addEventListener("click", function () {
      block.previousElementSibling.classList.remove("d-none");
      block.classList.add('d-none');
    });
    card_wrapper.forEach(card => {
      card.addEventListener("click", (event) => {

        const radio = card.querySelector('input[type="radio"]');
        radio.checked = true;
        let changeEvent = new Event('change');
        radio.dispatchEvent(changeEvent);
        next_button?.classList.remove("disabled");
        next_button?.click();
        if (next_button?.classList.contains('submit-form-trigger')) {
          next_button?.addEventListener("click", function (event) {
            event.preventDefault();
            const checked_options = section.querySelectorAll("input[type='radio']:checked");
            var tags = '';
            var count = 5;
            var order = [2, 0, 1, 3];
            var orderDict = order.reduce((acc, item, index) => {
              acc[item] = index;
              return acc;
            }, {});

            const sortedOptions = Array.from(checked_options).sort((a, b) => {
              return orderDict[Array.from(checked_options).indexOf(a)] - orderDict[Array.from(checked_options).indexOf(b)]
            }
            );
            sortedOptions.forEach((option, index) => {
              var value;
              if (index == 0) {
                value = 'gf_475082=' + option.value;
              } else {
                count = count + 1;
                value = `gf_47551${count}=` + option.value;
              }
              if (tags == '') {
                tags = value;
              } else {
                tags = tags + "&" + value;
              }
            })
            const url = Shopify.routes.root + "collections/all?" + tags;
            location.href = url
          })
        } else {
          next_button?.addEventListener("click", function (e) {
            e.preventDefault();
            const prevSiblings = previousSiblings(block);
            const nextBlock = block.nextElementSibling;
            nextBlock.classList.remove('d-none')
            block.classList.add('selected', 'd-none');
            if (prevSiblings.length == 1) {
              const type = prevSiblings[0].dataset.value;
              const parent = block.dataset.value;
              const cardsTofilter = nextBlock.querySelectorAll(`.card-wrapper`);
              for (let index = 0; index < cardsTofilter.length; index++) {
                const card = cardsTofilter[index];
                card.classList.remove('d-none');
                // Compared against window.quizStrings rather than English
                // literals: on an Arabic storefront the label never equals
                // "Boy", so this whole swap used to no-op. The sibling block
                // below was already migrated; this one was missed.
                if (blocks[1].dataset.value == "Adults") {
                  const label = card.querySelector('label').innerText;
                  if (label == window.quizStrings.kidMale) {
                    card.querySelector('label').innerText = window.quizStrings.adultMale
                  }
                  if (label == window.quizStrings.kidFemale) {
                    card.querySelector('label').innerText = window.quizStrings.adultFemale
                  }
                } else {
                  const label = card.querySelector('label').innerText;
                  if (label == window.quizStrings.adultMale) {
                    card.querySelector('label').innerText = window.quizStrings.kidMale
                  }
                  if (label == window.quizStrings.adultFemale) {
                    card.querySelector('label').innerText = window.quizStrings.kidFemale
                  }
                }
                if (card.dataset.type != type && card.dataset.parent != parent) {
                  card.classList.add('d-none')
                }
              }
            }

          })
        }
      })
    });
    radios.forEach(radio => {
      radio.addEventListener("change", function (event) {
        section.querySelectorAll(".card-wrapper").forEach(card => {
          if (radio.value == "Adults") {
            const label = (card.querySelector('label').innerText).trim();
            if (label == window.quizStrings.kidMale) {
              card.querySelector('label').innerText = window.quizStrings.adultMale
            }
            if (label == window.quizStrings.kidFemale) {
              card.querySelector('label').innerText = window.quizStrings.adultFemale
            }
          } if (radio.value == "Kids") {
            const label = (card.querySelector('label').innerText).trim();
            if (label == window.quizStrings.adultMale) {
              card.querySelector('label').innerText = window.quizStrings.kidMale;
            }
            if (label == window.quizStrings.adultFemale) {
              card.querySelector('label').innerText = window.quizStrings.kidFemale
            }
          }

        });
        next_button?.classList.remove('disabled');
        block.dataset.value = radio.value;
        if (next_button?.classList.contains('submit-form-trigger')) {
          next_button?.addEventListener("click", function (event) {
            event.preventDefault();
            const checked_options = section.querySelectorAll("input[type='radio']:checked");
            var tags = '';
            var count = 5;
            var order = [2, 0, 1, 3];
            var orderDict = order.reduce((acc, item, index) => {
              acc[item] = index;
              return acc;
            }, {});

            const sortedOptions = Array.from(checked_options).sort((a, b) => {
              return orderDict[Array.from(checked_options).indexOf(a)] - orderDict[Array.from(checked_options).indexOf(b)]
            }
            );
            sortedOptions.forEach((option, index) => {
              var giftRecipient;
              if (Array.from(checked_options)[0].value == 'gift') {
                if (Array.from(sortedOptions)[2].value == 'Child') {
                  giftRecipient = '445215211800'
                }
                if (Array.from(sortedOptions)[2].value == 'Adults') {
                  giftRecipient = '464491643160'
                }
                tags = `gf_475082=${Array.from(sortedOptions)[0].value}&gf_475518=${Array.from(sortedOptions)[3].value}&gf_475521=${giftRecipient}`
                return;
              }
              else {
                var value;
                if (index == 0) {
                  value = 'gf_475082=' + option.value;
                } else {
                  count = count + 1;
                  value = `gf_47551${count}=` + option.value;
                }
                if (tags == '') {
                  tags = value;
                } else {
                  tags = tags + "&" + value;
                }
              }
            })
            const url = Shopify.routes.root + "collections/all?" + tags;
            location.href = url;
          })
        } else {
          next_button?.addEventListener("click", function (e) {
            e.preventDefault();
            const prevSiblings = previousSiblings(block);
            const nextBlock = block.nextElementSibling;
            nextBlock.classList.remove('d-none')
            block.classList.add('selected', 'd-none');
            if (prevSiblings.length == 1) {
              const type = prevSiblings[0].dataset.value.toLowerCase();
              const parent = block.dataset.value.toLowerCase();
              const cardsTofilter = nextBlock.querySelectorAll(`.card-wrapper`);
              for (let index = 0; index < cardsTofilter.length; index++) {
                const card = cardsTofilter[index];
                const dataParent = card.getAttribute('data-parent'), dataType = card.getAttribute('data-type').toLowerCase();
                card.classList.add('d-none');
                if (dataType == type && dataParent == parent) {
                  card.classList.remove('d-none')
                }
              }
            }

          })
        }

      })
    })

    if (window.innerWidth < 1024) {
      insertAfter(cards_wrapper, title);
    } else {
      insertAfter(cards_wrapper, title_wrapper);
    }
    window.addEventListener("resize", (event) => {
      if (window.innerWidth < 1024) {
        insertAfter(cards_wrapper, title);
      } else {
        insertAfter(cards_wrapper, title_wrapper);
      }
    });

  });
});

const menu_toggles = document.querySelectorAll('.mega-menu summary.link');
const mega_content = document.querySelectorAll(".mega-menu .mega-menu__content");
const plain_menu_links = document.querySelectorAll('.header__inline-menu .list-menu--inline > li > a.header__menu-item');
const search_toggler_desk = document.querySelector(".header__icons .header__icon--search");
const desk_search = document.querySelector('.desk-search-drawer')
const search_close_desk = document.querySelector('.desk-search-drawer .modal__close-button');

menu_toggles.forEach(element => {
  element.addEventListener('mouseenter', function (event) {
    hideAllmenus();
    if (event.currentTarget.closest('details') != null) {
      if (!event.currentTarget.closest('details').hasAttribute('open')) {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        event.currentTarget.closest('details').setAttribute('open', '');
      }
    } else {
      hideAllmenus();
    }
  })
});

// Close any open mega menu when hovering a top-level link that has no submenu
plain_menu_links.forEach(element => {
  element.addEventListener('mouseenter', hideAllmenus);
});

mega_content.forEach(element => {
  element.addEventListener('mouseleave', function (event) {
    hideAllmenus();
    if (event.currentTarget.closest('details').hasAttribute('open')) {
      event.currentTarget.previousElementSibling.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      event.currentTarget.closest('details').removeAttribute('open');
    }
  })
});

if (!window.useSearchaniseSearch) {
search_toggler_desk?.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  desk_search?.classList.toggle('is-shown');
  document.querySelector('body')?.classList.toggle('drawer-open');
});

search_close_desk?.addEventListener("click", (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  desk_search?.classList.remove('is-shown');
  document.querySelector('body')?.classList.remove('drawer-open', 'overflow-hidden');
});
}

function hideAllmenus() {
  menu_toggles.forEach(element => {
    element.setAttribute('aria-expanded', 'false');
    element.closest('details').removeAttribute('open');
  })
}

function closeSubmenu(detailsElement) {
  const parentMenuElement = detailsElement?.closest('.submenu-open');
  parentMenuElement && parentMenuElement.classList.remove('submenu-open');
  detailsElement.classList.remove('menu-opening');
  detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
  removeTrapFocus(detailsElement.querySelector('summary'));
  closeAnimation(detailsElement);
}

function closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}

function isOtherCitySelected() {
  const selectedCity = getNormalizedSelectedCity();
  return selectedCity === 'OTHER CITY';
}

function getNormalizedSelectedCity() {
  const rawCity = (localStorage.getItem('selectedCity') || window.defaultCity || 'RIYADH')
    .toString()
    .replace(/[\u200e\u200f\u202a-\u202e]/g, '')
    .trim()
    .toLowerCase();

  if (['riyadh', 'الرياض'].includes(rawCity)) return 'RIYADH';

  if ([
    'other city',
    'other cities',
    'jeddah',
    'doha',
    window.locations?.OTHER_CITY?.toLowerCase(),
    window.locations?.OTHER_CITIES?.toLowerCase(),
    window.locations?.JEDDAH?.toLowerCase(),
    window.locations?.DOHA?.toLowerCase()
  ].includes(rawCity)) {
    return 'OTHER CITY';
  }

  return rawCity === 'riyadh' ? 'RIYADH' : 'OTHER CITY';
}

function applyCityBasedVisibility() {
  var selectedCity = getNormalizedSelectedCity();
  var className = '.otherCity';
  var notClassName = '.Riyadh';
  var riyadhCartItem = document.querySelector('.Riyadh_exclusive_cart-item');
  var riyadhPdpElements = document.querySelectorAll('.Riyadh_exclusive-PDP');

  if (selectedCity === 'RIYADH') {
    if (riyadhCartItem) {
      riyadhCartItem.classList.add('hidden');
      document.querySelector('.cart__select-shipment')?.removeAttribute('disabled');
    }
    riyadhPdpElements.forEach((element) => element.classList.add('hidden'));
  } else {
    className = '.Riyadh';
    notClassName = '.otherCity';
    if (riyadhCartItem) {
      riyadhCartItem.classList.remove('hidden');
      document.querySelector('.cart__select-shipment')?.setAttribute('disabled', true);
    }
    riyadhPdpElements.forEach((element) => element.classList.remove('hidden'));
  }

  document.querySelectorAll(className).forEach((element) => element.classList.add('hidden'));
  document.querySelectorAll(notClassName).forEach((element) => element.classList.remove('hidden'));

  syncAddToCartAvailabilityByCity();
}

window.applyCityBasedVisibility = applyCityBasedVisibility;
window.getNormalizedSelectedCity = getNormalizedSelectedCity;

const LOCATION_PICKED_AT_KEY = 'locationPickedAt';
const LOCATION_PICKED_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function rememberLocationPicked() {
  try {
    localStorage.setItem(LOCATION_PICKED_AT_KEY, String(Date.now()));
    sessionStorage.setItem('locationPicked', 'true');
  } catch (error) {
    // Ignore quota / private-mode failures
  }
}

function hasRecentLocationPick() {
  try {
    const rawPickedAt = localStorage.getItem(LOCATION_PICKED_AT_KEY);
    if (rawPickedAt) {
      const pickedAt = Number(rawPickedAt);
      return Number.isFinite(pickedAt) && pickedAt > 0 && (Date.now() - pickedAt) < LOCATION_PICKED_TTL_MS;
    }

    if (localStorage.getItem('selectedCity') || sessionStorage.getItem('locationPicked') === 'true') {
      rememberLocationPicked();
      return true;
    }
  } catch (error) {
    return false;
  }

  return false;
}

window.rememberLocationPicked = rememberLocationPicked;
window.hasRecentLocationPick = hasRecentLocationPick;

function syncCityFilteredContent() {
  const selectedCity = getNormalizedSelectedCity();
  window.selectedCity = selectedCity;

  document.querySelectorAll('.predictive-search__list-item').forEach((element) => {
    element.classList.remove('d-none');
    if (selectedCity === 'RIYADH' && element.getAttribute('data-othercity')) {
      element.classList.add('d-none');
    }
    if (selectedCity === 'OTHER CITY' && element.getAttribute('data-Riyadh')) {
      element.classList.add('d-none');
    }
  });

  const searchHeader = document.querySelector('.template-search__header');
  if (searchHeader) {
    searchHeader.querySelector('.OtherCity')?.classList.toggle('d-none', selectedCity === 'RIYADH');
    searchHeader.querySelector('.Riyadh')?.classList.toggle('d-none', selectedCity === 'OTHER CITY');
  }
}

window.syncCityFilteredContent = syncCityFilteredContent;

function openCityLocationModal() {
  document.querySelector('city-modal')?.open?.();
}

function openCityAtcNotificationModal() {
  document.querySelector('city-atc-notification-modal')?.open?.();
}

function bindCartAddFormGuards() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  addToCartForms.forEach((form) => {
    if (form.dataset.cityAtcGuardBound === 'true') return;

    form.addEventListener('submit', (event) => {
      if (!isOtherCitySelected()) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }, true);

    form.dataset.cityAtcGuardBound = 'true';
  });
}

const CITY_ATC_BUTTON_SELECTOR = 'button[name="add"], .product-form__submit:not(.sticky-atc__whatsapp), .quick-add__submit, sticky-atc .buy';

function bindCityAtcClickHandlers() {
  if (document.body?.dataset.cityAtcClickBound === 'true') return;

  document.body.addEventListener('click', (event) => {
    if (!isOtherCitySelected()) return;

    const button = event.target.closest(CITY_ATC_BUTTON_SELECTOR);
    if (!button?.classList.contains('city-atc-blocked')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openCityAtcNotificationModal();
  }, true);

  document.body.dataset.cityAtcClickBound = 'true';
}

function syncAddToCartAvailabilityByCity() {
  const shouldDisable = isOtherCitySelected();
  const atcButtons = document.querySelectorAll(CITY_ATC_BUTTON_SELECTOR);

  atcButtons.forEach((button) => {
    if (!(button instanceof HTMLElement)) return;

    const isNativeButton = button.tagName === 'BUTTON';
    if (shouldDisable) {
      button.classList.add('city-atc-blocked');
      button.classList.remove('disabled');
      button.removeAttribute('aria-disabled');
      if (isNativeButton) {
        button.disabled = false;
      } else {
        button.removeAttribute('tabindex');
      }
      return;
    }

    button.classList.remove('city-atc-blocked', 'disabled');
    button.removeAttribute('aria-disabled');
    if (isNativeButton) {
      button.disabled = false;
    } else {
      button.removeAttribute('tabindex');
    }
  });

  bindCartAddFormGuards();
  bindCityAtcClickHandlers();
}

let cityAtcObserver = null;
function initCityAtcGuardObserver() {
  if (cityAtcObserver || !document.body) return;

  cityAtcObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes?.length) continue;
      syncAddToCartAvailabilityByCity();
      break;
    }
  });

  cityAtcObserver.observe(document.body, { childList: true, subtree: true });
}

/*
 * Switching language POSTs to /localization and reloads the page, which wipes
 * anything the customer had typed but not yet added to the cart -- the custom
 * message on a product, a half-written contact form. Nothing in the theme
 * persisted those, so they were simply gone.
 *
 * Fields opt in with `data-preserve-on-locale-switch`, so a new input only has
 * to carry the attribute; nothing here needs to know which fields exist.
 */
const LOCALE_SWITCH_STASH_KEY = 'locale_switch_form_state';
const LOCALE_SWITCH_STASH_TTL_MS = 15 * 60 * 1000;

function preservedLocaleSwitchFields() {
  return document.querySelectorAll('[data-preserve-on-locale-switch]');
}

/*
 * A field whose id and name are both derived from something translatable has no
 * stable identity across the switch, so it opts out with `data-preserve-key`.
 * The metaobject-driven property inputs are the case that forced this: Arabic
 * renders id="input-العبارة-على-الخلفية" / name="properties[العبارة على الخلفية]"
 * where English renders id="input-message-on-backdrop", so every key missed and
 * the draft was silently dropped.
 */
function localeSwitchFieldKey(field) {
  return field.dataset?.preserveKey || field.id || field.name || '';
}

function stashLocaleSwitchState() {
  try {
    const values = {};
    preservedLocaleSwitchFields().forEach((field) => {
      const key = localeSwitchFieldKey(field);
      if (key && field.value) values[key] = field.value;
    });
    if (!Object.keys(values).length) {
      sessionStorage.removeItem(LOCALE_SWITCH_STASH_KEY);
      return;
    }
    sessionStorage.setItem(
      LOCALE_SWITCH_STASH_KEY,
      JSON.stringify({ savedAt: Date.now(), path: window.location.pathname, values })
    );
  } catch (e) {
    /* private mode / storage full — losing the draft is no worse than today */
  }
}

function restoreLocaleSwitchState() {
  let raw = null;
  try {
    raw = sessionStorage.getItem(LOCALE_SWITCH_STASH_KEY);
  } catch (e) {
    return;
  }
  if (!raw) return;

  const discard = () => {
    try {
      sessionStorage.removeItem(LOCALE_SWITCH_STASH_KEY);
    } catch (e) {
      /* nothing to do */
    }
  };

  let payload = null;
  try {
    payload = JSON.parse(raw);
  } catch (e) {
    discard();
    return;
  }
  if (!payload || !payload.values) {
    discard();
    return;
  }
  // Expire, so a stash left behind by an abandoned tab cannot repopulate a form
  // on some unrelated later visit.
  if (!(Date.now() - Number(payload.savedAt) < LOCALE_SWITCH_STASH_TTL_MS)) {
    discard();
    return;
  }

  // Consume the stash only after it matched something on this page. The switch
  // may land somewhere without the stashed fields (a return_to drift, or
  // autoLangredirect bouncing the dying page while this still runs) — deleting
  // up front would destroy the draft the feature exists to save. Until a page
  // with the fields loads, the TTL is the garbage collector.
  let matched = false;
  preservedLocaleSwitchFields().forEach((field) => {
    const key = localeSwitchFieldKey(field);
    if (!key || !(key in payload.values)) return;
    matched = true;
    // Never overwrite something already on screen: whatever put it there is
    // newer than this stash.
    if (field.value) return;
    field.value = payload.values[key];

    // Setting .value fires nothing, and the product form depends on events:
    // global.js mirrors these inputs into the hidden line-item property fields
    // on `keyup` (the visible input lives outside the product form, so without
    // this the text shows on screen but never reaches the cart), and
    // product-form.js clears its validation message on `input`.
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    field.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
  });
  if (matched) discard();
}

// autoLangredirect.js can bounce the page to the stored preferred_language on
// load, so restore must tolerate running on a different URL than the one that
// stashed. It matches fields by id/name rather than by path for that reason.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', restoreLocaleSwitchState);
} else {
  restoreLocaleSwitchState();
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul.disclosure__list'),
    };

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.panel?.querySelectorAll('li a').forEach((item) => {
      if (item.closest('.language-list')) return;
      item.addEventListener('click', (event) => { this.citySelector(event); });
    });
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    document.addEventListener('click', this.handleDocumentClick);
    this.changeCity();
    this.changeForm();
    this.setCurrentCityInElement();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  setCurrentCityInElement() {
    const location_names = this.elements.button.querySelectorAll('span.location_name');
    location_names.forEach(el => el.classList.add('hidden'));

    const pickedCity = getNormalizedSelectedCity();

    if (pickedCity === 'RIYADH') {
      this.elements.button.querySelector('span.riyadh')?.classList.remove('hidden');
    } else {
      this.elements.button.querySelector('span.other_city')?.classList.remove('hidden');
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    const languageInput = this.querySelector('input[name="language_code"]');
    if (!languageInput) return;

    const link = event.currentTarget;
    // .language-list is what separates a language click from a city one, and a
    // city click clears the cart. Leave it alone.
    if (!link.closest('.language-list')) return;

    const selectedLang = (link.dataset.value || '').toLowerCase();
    // Accept whatever this switcher actually offers, rather than a hardcoded
    // pair, so a language added in Shopify Markets works with no JS change.
    const offered = Array.from(this.querySelectorAll('.language-list a[data-value]')).map((option) =>
      (option.dataset.value || '').toLowerCase()
    );
    if (!selectedLang || !offered.includes(selectedLang)) return;

    event.preventDefault();

    // Both languages are shown now, so the current one is clickable; switching
    // to the language you are already in would just reload the page.
    if (link.getAttribute('aria-current') === 'true') return;

    const form = this.querySelector('form');
    languageInput.value = selectedLang;
    localStorage.setItem('preferred_language', selectedLang);
    sessionStorage.setItem('language_applied', 'true');
    stashLocaleSwitchState();
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  handleDocumentClick(event) {
    if (this.elements.panel.hasAttribute('hidden')) return;
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  resolveCityFromLink(link) {
    if (!link) return null;

    const explicitCity = (link.dataset.city || '').trim().toUpperCase();
    if (explicitCity === 'RIYADH' || explicitCity === 'OTHER CITY') {
      return explicitCity;
    }

    const label = link.innerText.toString().replace(/\s+/g, ' ').trim();
    if (!label) return null;

    if (label === window.locations?.RIYADH || label === 'RIYADH') {
      return 'RIYADH';
    }

    if (
      label === window.locations?.OTHER_CITY ||
      label === window.locations?.OTHER_CITIES ||
      label === window.locations?.JEDDAH ||
      label === window.locations?.DOHA ||
      label === 'OTHER CITY'
    ) {
      return 'OTHER CITY';
    }

    return null;
  }

  citySelector(event) {
    if (event.currentTarget.closest('.language-list')) return;

    event.preventDefault();
    this.elements.panel.toggleAttribute('hidden');

    const pickedCity = this.resolveCityFromLink(event.currentTarget);
    if (!pickedCity) return;

    const location_names = this.elements.button.querySelectorAll('span.location_name');
    location_names.forEach(el => el.classList.add('hidden'));

    if (pickedCity === 'RIYADH') {
      this.elements.button.querySelector('span.riyadh')?.classList.remove('hidden');
    } else {
      this.elements.button.querySelector('span.other_city')?.classList.remove('hidden');
    }

    const isDeferredCityModalSelection =
      this.closest('city-modal') !== null || this.closest('city-atc-notification-modal') !== null;
    if (isDeferredCityModalSelection) {
      this.setAttribute('data-pending-city', pickedCity);
      return;
    }

    this.applyCitySelection(pickedCity);
  }

  applyCitySelection(pickedCity) {
    if (pickedCity !== 'RIYADH' && pickedCity !== 'OTHER CITY') return;

    const previousCity = getNormalizedSelectedCity();
    const normalizedCity = pickedCity === 'RIYADH' ? 'RIYADH' : 'OTHER CITY';

    localStorage.setItem('selectedCity', normalizedCity);
    rememberLocationPicked();
    window.selectedCity = normalizedCity;

    document.querySelectorAll('localization-form').forEach((formEl) => {
      formEl.setCurrentCityInElement();
    });

    this.changeCity();
    this.changeForm();
    syncCityFilteredContent();

    const isDeferredCityModalSelection =
      this.closest('city-modal') !== null || this.closest('city-atc-notification-modal') !== null;
    const isAnnouncementBarSelection = this.closest('#shopify-section-announcement-bar') !== null;

    if (normalizedCity === 'OTHER CITY' && (isDeferredCityModalSelection || isAnnouncementBarSelection)) {
      if (isAnnouncementBarSelection) {
        this.triggerKlaviyoLocationForm();
      }
      document.dispatchEvent(new CustomEvent('city:changed', { detail: { city: normalizedCity } }));
      return;
    }

    if (previousCity === normalizedCity) {
      document.dispatchEvent(new CustomEvent('city:changed', { detail: { city: normalizedCity } }));
      return;
    }

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: '',
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart clear failed');
        return response.json();
      })
      .then(async (cart) => {
        if (window.TwinkleCart?.refreshFromServer) {
          await window.TwinkleCart.refreshFromServer();
        } else if (window.TwinkleCart?.dispatchCartUpdate) {
          window.TwinkleCart.dispatchCartUpdate(cart);
        }

        document.dispatchEvent(new CustomEvent('city:changed', { detail: { city: normalizedCity, cart } }));
      })
      .catch((error) => {
        console.error('City switch error:', error);
        document.dispatchEvent(new CustomEvent('city:changed', { detail: { city: normalizedCity } }));
      });
  }

  triggerKlaviyoLocationForm() {
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    const shopifyLocale = (window.Shopify?.locale || '').toLowerCase();
    const preferredLanguage = (localStorage.getItem('preferred_language') || '').toLowerCase();

    const isArabic =
      htmlLang.startsWith('ar') ||
      shopifyLocale === 'ar' ||
      preferredLanguage === 'ar';

    const klaviyoFormId = isArabic ? 'WNVwJu' : 'V6M25A';
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', klaviyoFormId]);
  }


  changePDPbtn() {
    const template = document?.querySelector('.template-main-product-kids') || document.querySelector('.main_new-main-product') || document.querySelector('.template-product-bundle-gift') || document.querySelector('.template-cake-balloon');
    const productFormBtn = document.querySelector('product-form form [name="add"]');
    const stickyATCbtn = document.querySelector('sticky-atc .buy');
    const productFormBtnSecondary = document.querySelector('.customize-wrapper [name="add"]');
    var selectedCity = localStorage.getItem('selectedCity') ?? 'riyadh';
    var Riyadh_PDP = document.querySelector('.Riyadh_exclusive-PDP');
  }

  changeForm() {
    var selectedCity = getNormalizedSelectedCity();
    const template = document?.querySelector('.template-main-product-kids') || document.querySelector('.main_new-main-product') || document.querySelector('.template-product-bundle-gift') || document.querySelector('.template-cake-balloon');

    if (!template) return;

    const customizeWrapper = template.querySelector('.customize-wrapper');
    if (!customizeWrapper) return;

    // Cake toggle only — avoid the accessories switch when include-cake is disabled
    const cakeToggle = customizeWrapper.querySelector('.ingredients_toggle');
    const switchWrapper = cakeToggle?.closest('.switch-wrapper') || null;
    const formWrapper = customizeWrapper.querySelector('.form-wrapper');
    const duplicateBtn = customizeWrapper.querySelector('.buttons-wrapper');
    const additionalProps = template.querySelectorAll('.additional-props .prop-wrapper-msg');

    if (selectedCity === 'OTHER CITY') {
      switchWrapper?.classList.add('hidden');
      formWrapper?.classList.add('hidden');
      if (document.querySelector('.main_new-main-product')) {
        duplicateBtn?.classList.add('hidden');
      }
    } else {
      switchWrapper?.classList.remove('hidden');
      if (document.querySelector('.main_new-main-product')) {
        duplicateBtn?.classList.remove('hidden');
      }
      additionalProps.forEach((element) => {
        element.classList.remove('hidden');
      });
    }
  }

  changeCity() {
    applyCityBasedVisibility();
    if (document.querySelectorAll('.Riyadh_exclusive-PDP').length) {
      this.changePDPbtn();
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    applyCityBasedVisibility();
    syncCityFilteredContent();
    syncAddToCartAvailabilityByCity();
    initCityAtcGuardObserver();
  });
} else {
  applyCityBasedVisibility();
  syncCityFilteredContent();
  syncAddToCartAvailabilityByCity();
  initCityAtcGuardObserver();
}

const secondaryATC = document.querySelector('.customize-wrapper [name="add"]');

if (secondaryATC) {
  secondaryATC.addEventListener('click', function () {
    const sectionId = this.dataset.section;
    const productForm = document.getElementById(`product-form-${sectionId}`);
    const pdpATC = productForm.querySelector('[name="add"]');

    if (pdpATC) {
      pdpATC.click();
    }
  });
}


var acc = document.getElementsByClassName("menu-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
const form = document.querySelector('form#ContactFooter');
const emailEl = document.querySelector('input[name="contact[email]"]');

const checkUsername = () => {

  let valid = false;

  const min = 3,
    max = 25;

  const username = usernameEl?.value.trim();

  if (!isRequired(username)) {
    showError(usernameEl, window.formStrings.usernameBlank);
  } else if (!isBetween(username.length, min, max)) {
    showError(usernameEl, window.formStrings.usernameLength.replace('[min]', min).replace('[max]', max))
  } else {
    showSuccess(usernameEl);
    valid = true;
  }
  return valid;
};


const checkEmail = () => {
  let valid = false;
  const email = emailEl.value.trim();
  if (!isRequired(email)) {
    showError(emailEl, window.formStrings.emailBlank);
  } else if (!isEmailValid(email)) {
    showError(emailEl, window.formStrings.emailInvalid)
  } else {
    showSuccess(emailEl);
    valid = true;
  }
  return valid;
};

const checkPassword = () => {
  let valid = false;


  const password = passwordEl.value.trim();

  if (!isRequired(password)) {
    showError(passwordEl, window.formStrings.passwordBlank);
  } else if (!isPasswordSecure(password)) {
    showError(passwordEl, window.formStrings.passwordInsecure);
  } else {
    showSuccess(passwordEl);
    valid = true;
  }

  return valid;
};

const checkConfirmPassword = () => {
  let valid = false;
  const confirmPassword = confirmPasswordEl.value.trim();
  const password = passwordEl.value.trim();

  if (!isRequired(confirmPassword)) {
    showError(confirmPasswordEl, window.formStrings.passwordConfirmBlank);
  } else if (password !== confirmPassword) {
    showError(confirmPasswordEl, window.formStrings.passwordMismatch);
  } else {
    showSuccess(confirmPasswordEl);
    valid = true;
  }

  return valid;
};

const isEmailValid = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const isPasswordSecure = (password) => {
  const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  return re.test(password);
};

const isRequired = value => value === '' ? false : true;
const isBetween = (length, min, max) => length < min || length > max ? false : true;


const showError = (input, message) => {
  const formField = input.parentElement;
  formField.classList.remove('success');
  formField.classList.add('error');
  const error = formField.querySelector('small');
  error.textContent = message;
};

const showSuccess = (input) => {
  const formField = input.parentElement;
  formField.classList.remove('error');
  formField.classList.add('success');
  const error = formField.querySelector('small');
  error.textContent = '';
}


form.addEventListener('submit', function (e) {
  e.preventDefault();

  let isUsernameValid = checkUsername(),
    isEmailValid = checkEmail(),
    isPasswordValid = checkPassword(),
    isConfirmPasswordValid = checkConfirmPassword();

  let isFormValid = isUsernameValid &&
    isEmailValid &&
    isPasswordValid &&
    isConfirmPasswordValid;

  if (isFormValid) {

  }
});

debounce = (fn, delay = 500) => {
  let timeoutId;
  return (...args) => {

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      fn.apply(null, args)
    }, delay);
  };
};

form.addEventListener('input', debounce(function (e) {
  switch (e.target.name) {
    case 'username':
      checkUsername();
      break;
    case 'email':
      checkEmail();
      break;
    case 'password':
      checkPassword();
      break;
    case 'confirm-password':
      checkConfirmPassword();
      break;
  }
}));

const listItems = document.querySelectorAll('.predictive-search__list-item');
const searchHeader = document.querySelector('.template-search__header');

listItems.forEach(element => {
  if (selectedCity.trim() == "RIYADH") {
    const isOtherCity = element.getAttribute('data-othercity') ? 'true' : '';
    if (isOtherCity == 'true') {
      element.classList.add('d-none');
    }
  }
  if (selectedCity.trim() == "OTHER CITY") {
    const isRiyadh = element.getAttribute('data-Riyadh') ? 'true' : '';
    if (isRiyadh == 'true') {
      element.classList.add('d-none');
    }
  }
});

if (selectedCity.trim() == "RIYADH") {
  searchHeader?.querySelector('.OtherCity')?.classList.add('d-none');
}
if (selectedCity.trim() == "OTHER CITY") {
  searchHeader?.querySelector('.Riyadh').classList.add('d-none');
}